import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakcabb() {


const cardData = {
keyword: "Pune to Ashtavinayak Cab",
headingDescription: "Pune to Ashtavinayak Cab provides convenient private transportation for devotees planning the traditional Ashtavinayak pilgrimage across Maharashtra. The yatra covers eight revered temples of Lord Ganesha at Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. Citysky Cabs offers suitable vehicles for couples, families, senior citizens, and larger pilgrimage groups, with options such as sedan, Ertiga, Innova Crysta, and other spacious vehicles. The complete Ashtavinayak journey can be customized as a one-day, multi-day, round-trip, or package tour according to the preferred temple sequence, travel duration, passenger count, and sightseeing requirements.",
topPlaces: [
{
title: "Mayureshwar Temple, Morgaon",
description: "Mayureshwar Temple at Morgaon is traditionally regarded as an important starting point of the Ashtavinayak pilgrimage. Devotees traveling from Pune can visit the temple through a private cab and continue toward the remaining Ashtavinayak destinations according to their planned yatra route."
},
{
title: "Siddhivinayak Temple, Siddhatek",
description: "Siddhivinayak Temple at Siddhatek is one of the eight sacred Ashtavinayak temples dedicated to Lord Ganesha. A private vehicle provides convenient transportation for devotees and allows the temple to be included smoothly in a multi-stop pilgrimage itinerary."
},
{
title: "Ballaleshwar Temple, Pali",
description: "Ballaleshwar Temple at Pali is an important stop on the Ashtavinayak circuit and is associated with the devotion of Ballala. Travelers from Pune can include Pali in their customized pilgrimage route while traveling comfortably between the different temple destinations."
},
{
title: "Varadvinayak Temple, Mahad",
description: "Varadvinayak Temple at Mahad is another revered destination in the Ashtavinayak yatra. Private cab travel makes it convenient for families and groups to reach Mahad and continue their religious journey without arranging separate transportation between pilgrimage locations."
},
{
title: "Chintamani Temple, Theur",
description: "Chintamani Temple at Theur is one of the prominent Ashtavinayak temples located within practical reach of Pune. Devotees can include Theur as part of their planned circuit and use a dedicated vehicle to maintain a flexible darshan and travel schedule."
},
{
title: "Girijatmaj Temple, Lenyadri",
description: "Girijatmaj Temple at Lenyadri is a distinctive Ashtavinayak pilgrimage destination situated among the Lenyadri hills. A private cab can provide transportation to the area, allowing devotees to include this temple along with other religious and sightseeing stops."
},
{
title: "Vighneshwar Temple, Ozar",
description: "Vighneshwar Temple at Ozar is an important temple on the Ashtavinayak circuit and is dedicated to Lord Ganesha in the form of Vighneshwar. Devotees can visit Ozar as part of a customized multi-day yatra using a private vehicle throughout the journey."
},
{
title: "Mahaganapati Temple, Ranjangaon",
description: "Mahaganapati Temple at Ranjangaon is one of the eight sacred Ashtavinayak temples and is a popular pilgrimage destination near Pune. A private cab makes it convenient to include Ranjangaon in the temple circuit along with the other Ashtavinayak stops."
},
{
title: "Jejuri Khandoba Temple",
description: "Jejuri is a well-known pilgrimage destination dedicated to Lord Khandoba and can be added to an extended religious itinerary from Pune. Devotees completing the Ashtavinayak circuit can include Jejuri when they want to visit an additional important temple."
},
{
title: "Shree Kshetra Dehu",
description: "Dehu is a significant devotional destination associated with Sant Tukaram Maharaj and can be included in an extended pilgrimage journey from Pune. Travelers can combine Dehu with the Ashtavinayak circuit when planning a broader Maharashtra religious tour."
}
],
services: [
{
name: "Ashtavinayak darshan cab pune",
description: "Ashtavinayak darshan cab Pune provides private transportation for devotees planning to visit the eight sacred Ganesha temples across Maharashtra. The vehicle can remain dedicated to the group throughout the pilgrimage, making it convenient to follow a customized temple sequence and travel schedule."
},
{
name: "Car rental for ashtavinayak from pune",
description: "Car rental for Ashtavinayak from Pune offers a dedicated vehicle for families, couples, senior citizens, and pilgrimage groups. The rental can be arranged for a direct circuit or multi-day yatra according to the number of temples, travel days, passenger count, and luggage requirements."
},
{
name: "Cost of ashtavinayak yatra tour by car from pune",
description: "Cost of Ashtavinayak yatra tour by car from Pune depends on factors such as vehicle category, number of passengers, number of travel days, total route, and additional sightseeing requirements. Travelers can select a suitable vehicle and discuss the complete itinerary for a customized package."
},
{
name: "pune to ashtavinayak darshan cab",
description: "Pune to Ashtavinayak darshan cab provides private transportation for devotees visiting the complete Ashtavinayak temple circuit. The journey can be organized as a one-day or multi-day pilgrimage with suitable stops for darshan, meals, rest, and overnight stays."
},
{
name: "ashtavinayak tour from pune cab",
description: "Ashtavinayak tour from Pune cab provides dedicated road transportation for devotees undertaking the traditional Ganesha pilgrimage. The itinerary can be customized around temple sequence, travel duration, passenger requirements, and additional religious destinations."
},
{
name: "pimpri chinchwad to ashtavinayak cab",
description: "Pimpri Chinchwad to Ashtavinayak cab provides private transportation for devotees beginning their pilgrimage from the PCMC region. Travelers can arrange a suitable vehicle for families or groups and cover the eight temples through a planned multi-stop route."
},
{
name: "kothrud to ashtavinayak darshan cabs",
description: "Kothrud to Ashtavinayak darshan cabs provide convenient private transportation for devotees starting their yatra from Kothrud. A dedicated cab can cover the temple circuit according to the selected itinerary while providing flexibility for family and group travel."
},
{
name: "pune to ashtavinayak innova crysta",
description: "Pune to Ashtavinayak Innova Crysta provides a spacious vehicle option for families and pilgrimage groups traveling across the eight temple destinations. The additional cabin and luggage space can be useful for multi-day religious journeys."
},
{
name: "pune to ashtavinayak tour package",
description: "Pune to Ashtavinayak tour package provides a customized pilgrimage arrangement covering the eight revered Ganesha temples. The itinerary can be planned according to the number of days, preferred vehicle, passenger count, temple sequence, and additional sightseeing requirements."
},
{
name: "pune to ashtavinayak ertiga Cabs",
description: "Pune to Ashtavinayak Ertiga Cabs provide a spacious private transportation option for families and medium-sized pilgrimage groups. The vehicle can be used throughout the temple circuit, helping travelers remain together while carrying their luggage."
},
{
name: "pune to ashtavinayak sedan cabs",
description: "Pune to Ashtavinayak sedan cabs provide a practical private travel option for couples, small families, and compact groups. A sedan can be arranged for a customized temple circuit with suitable travel timing and selected pilgrimage stops."
},
{
name: "online cab booking pune",
description: "Online cab booking Pune allows travelers to arrange private transportation for their Ashtavinayak pilgrimage before departure. Advance booking can help organize a suitable vehicle and planned itinerary for families, senior citizens, and devotional groups."
},
{
name: "online cab booking pimpri chinchwad",
description: "Online cab booking Pimpri Chinchwad provides a convenient way for devotees in the PCMC region to arrange transportation for an Ashtavinayak yatra. Travelers can plan their vehicle according to passenger count, luggage, travel days, and temple circuit requirements."
},
{
name: "ashtavinayak tour from pune",
description: "Ashtavinayak tour from Pune provides a private travel arrangement for devotees visiting all eight Ganesha temples. The tour can be customized into a suitable one-day or multi-day pilgrimage depending on the selected route, darshan schedule, and group requirements."
},
{
name: "ashtavinayak tour from pune by car package",
description: "Ashtavinayak tour from Pune by car package provides dedicated transportation for a complete Ganesha pilgrimage. The package can be planned around the eight temple destinations, preferred vehicle, travel duration, passenger count, rest breaks, and optional religious sightseeing."
}
],
tableData: [
["Ashtavinayak darshan cab pune"],
["Car rental for ashtavinayak from pune"],
["Cost of ashtavinayak yatra tour by car from pune"],
["pune to ashtavinayak darshan cab"],
["ashtavinayak tour from pune cab"],
["pimpri chinchwad to ashtavinayak cab"],
["kothrud to ashtavinayak darshan cabs"],
["pune to ashtavinayak innova crysta"],
["pune to ashtavinayak tour package"],
["pune to ashtavinayak ertiga Cabs"],
["pune to ashtavinayak sedan cabs"],
["online cab booking pune"],
["online cab booking pimpri chinchwad"],
["ashtavinayak tour from pune"],
["ashtavinayak tour from pune by car package"]
],
whychoose: [
{
WhyChooseheading: "Complete Ashtavinayak Circuit",
WhyChoosedescription: "A dedicated private cab allows devotees to travel between all eight Ashtavinayak temples without arranging separate vehicles for different parts of the pilgrimage. The route can be organized according to the group's preferred temple sequence and available travel days."
},
{
WhyChooseheading: "Customized Yatra Planning",
WhyChoosedescription: "The pilgrimage can be structured as a one-day, two-day, or multi-day journey depending on the group's schedule. Temple darshan, meal breaks, rest periods, overnight stays, and additional religious destinations can be incorporated into the selected itinerary."
},
{
WhyChooseheading: "Multiple Vehicle Options",
WhyChoosedescription: "Vehicle selection can be matched with the size of the pilgrimage group and luggage requirements. Sedan options can suit smaller groups, while Ertiga and Innova Crysta provide additional seating and luggage space for families and larger devotional groups."
},
{
WhyChooseheading: "Family-Friendly Pilgrimage Travel",
WhyChoosedescription: "Private transportation provides greater convenience for families traveling with children, senior citizens, and luggage. The group can remain together throughout the temple circuit while planning breaks and travel timings according to their individual requirements."
},
{
WhyChooseheading: "Convenient Pickup Locations",
WhyChoosedescription: "Devotees can arrange transportation from suitable areas of Pune and the Pimpri Chinchwad region. This makes it easier to begin the Ashtavinayak pilgrimage directly from a convenient pickup point rather than arranging separate local transportation."
},
{
WhyChooseheading: "Suitable for Group Yatras",
WhyChoosedescription: "Families, friends, and devotional groups can select a vehicle according to their passenger count and travel requirements. Spacious vehicle options help accommodate luggage and maintain comfortable group travel during the multi-temple pilgrimage."
},
{
WhyChooseheading: "Flexible Darshan Schedule",
WhyChoosedescription: "A private vehicle gives travelers greater control over the timing of each temple visit and the duration spent at individual pilgrimage locations. The route can be adjusted around the group's preferred darshan schedule and planned overnight stops."
},
{
WhyChooseheading: "Advance Cab Booking",
WhyChoosedescription: "Advance booking helps devotees organize their preferred vehicle before starting the Ashtavinayak yatra. It is particularly useful for families, senior citizens, larger groups, festival-period travel, and multi-day pilgrimage itineraries requiring a dedicated vehicle."
}
]
};









const faqData = [
{
question: "How can I book a Pune to Ashtavinayak Cab with Citysky Cabs?",
answer: "Pilgrims planning an Ashtavinayak Yatra from Pune can enquire with Citysky Cabs by sharing the travel date, number of passengers, pickup location, preferred departure time, and expected itinerary. The cab arrangement can be planned according to the temples and destinations included in your pilgrimage."
},
{
question: "Can I hire a cab for the complete Ashtavinayak Yatra from Pune?",
answer: "A private cab can be arranged for travellers who want to visit multiple Ashtavinayak temples during one pilgrimage. Depending on the planned route, the journey can cover temples such as Morgaon, Siddhatek, Theur, Ranjangaon, Ozar, Lenyadri, Pali, and Mahad."
},
{
question: "Is Pune to Ashtavinayak Cab suitable for family pilgrimage trips?",
answer: "Families travelling with children, senior citizens, or several members can consider a private cab for the Ashtavinayak Yatra. Having dedicated transportation keeps the group together and provides greater flexibility for temple visits, meal breaks, rest stops, and the overall pilgrimage schedule."
},
{
question: "Can I book a one-day Ashtavinayak Cab from Pune?",
answer: "Travellers planning a shorter Ashtavinayak temple visit can enquire about a one-day cab arrangement based on the number of temples and route they wish to cover. Sharing the complete itinerary in advance helps Citysky Cabs understand the expected distance and travel schedule."
},
{
question: "Can I hire a cab for a multi-day Ashtavinayak Yatra from Pune?",
answer: "For devotees who prefer a relaxed pilgrimage over two or more days, a cab can be arranged around the selected temple sequence and stay locations. A multi-day plan can make it easier to include rest periods and spend sufficient time at each temple without rushing the journey."
},
{
question: "Which Ashtavinayak temples can be covered by cab from Pune?",
answer: "The traditional Ashtavinayak pilgrimage includes eight Ganesha temples at Morgaon, Siddhatek, Theur, Ranjangaon, Ozar, Lenyadri, Pali, and Mahad. Travellers can discuss their preferred temple sequence with Citysky Cabs while planning the cab itinerary."
},
{
question: "Can senior citizens travel comfortably for the Ashtavinayak Yatra by cab?",
answer: "A private cab can be a practical transportation choice for families travelling with elderly pilgrims because the group does not need to change vehicles between destinations. When making the enquiry, mention the number of senior passengers and any specific travel requirements so the journey can be planned accordingly."
},
{
question: "Can I use the Pune to Ashtavinayak Cab for temple sightseeing?",
answer: "Yes, travellers can plan the cab around temple visits and other agreed sightseeing stops along the route. Providing the preferred destinations, expected timings, passenger count, and trip duration allows the transportation schedule to be coordinated with the pilgrimage plan."
},
{
question: "Can I book an Ashtavinayak Cab for a group of devotees?",
answer: "Groups of friends, relatives, and devotees can enquire about a suitable cab for travelling together during the Ashtavinayak Yatra. The vehicle requirement can be discussed according to group size, luggage, number of travel days, temple itinerary, and pickup location in Pune."
},
{
question: "What details are required to arrange a Pune to Ashtavinayak Cab?",
answer: "To plan the cab service, share your Pune pickup point, journey date, passenger count, preferred departure time, selected Ashtavinayak temples, number of travel days, luggage requirements, and whether you need local return transportation. Citysky Cabs can use these details to coordinate the trip according to your pilgrimage itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Prakash Jadhav",
feedback:
"Our family was planning the Ashtavinayak Yatra from Pune and wanted to avoid managing different vehicles between the temples. Citysky Cabs arranged a private cab according to our planned route. Having everyone together made it much easier to coordinate temple visits, meals, and rest breaks during the pilgrimage.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Deshmukh",
feedback:
"We travelled with a group of relatives for an Ashtavinayak pilgrimage and needed transportation that could follow our temple schedule. Citysky Cabs coordinated the cab after we shared our itinerary and passenger details. The dedicated vehicle made the multi-stop journey more convenient, especially because some senior members were travelling with us.",
rating: 5
}
];
















    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Cab",
  "image": "https://www.cityskycab.in/assets/images/pune-to-ashtavinayak-cab.webp",
  "description": "Pune to Ashtavinayak Cab from Citysky Cabs is a comfortable private travel option for families, groups and devotees planning Ashtavinayak Darshan from Pune. The service covers Ashtavinayak Darshan Cab Pune, Car Rental for Ashtavinayak from Pune, Ashtavinayak Yatra Tour by Car and customized Ashtavinayak tour requirements. Travellers can choose a suitable vehicle based on group size, luggage and journey requirements, including spacious options such as Innova Crysta and Ertiga. The Ashtavinayak Yatra can be planned for visiting the eight revered Ganpati temples with flexible pickup and drop locations across Pune. Citysky Cabs provides private cab options for families, senior citizens, groups and devotees looking for a convenient road journey for their Ashtavinayak pilgrimage.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-ashtavinayak-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Pune to Ashtavinayak Cab | Darshan Car Rental & Yatra | +91 8554819191
  </title>

  <meta
    name="description"
    content="Pune to Ashtavinayak Cab by Citysky Cabs for comfortable Ganpati darshan. Book a private car rental for Ashtavinayak Yatra from Pune with Innova Crysta and Ertiga options."
  />

  <meta
    name="keywords"
    content="Pune to Ashtavinayak Cab, Ashtavinayak darshan cab Pune, Car rental for Ashtavinayak from Pune, Cost of Ashtavinayak yatra tour by car from Pune, Pune to Ashtavinayak, Pune to Ashtavinayak cab booking, Pune Ashtavinayak cab service, Ashtavinayak cab from Pune, Ashtavinayak taxi from Pune, Pune to Ashtavinayak car rental, Ashtavinayak Darshan from Pune, Ashtavinayak tour from Pune by car, Ashtavinayak Yatra from Pune, Ashtavinayak tour package from Pune, Pune to Ashtavinayak tour package, Ashtavinayak Darshan car rental Pune, Ashtavinayak Darshan taxi Pune, Ashtavinayak 8 Ganpati tour from Pune, 8 Ashtavinayak Darshan cab Pune, Pune Ashtavinayak round trip cab, Pune Ashtavinayak private cab, Pune Ashtavinayak Innova Crysta cab, Pune Ashtavinayak Ertiga cab, Innova Crysta for Ashtavinayak Darshan, Ertiga for Ashtavinayak Darshan, Ashtavinayak family tour cab Pune, Ashtavinayak temple tour by car Pune, Ashtavinayak pilgrimage cab Pune, Pune Ashtavinayak AC cab, Ashtavinayak outstation cab Pune, Ashtavinayak cab fare from Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<Helmet>
  <title>
    Pune to Ashtavinayak Cab | Darshan Car Rental & Yatra | +91 8554819191
  </title>

  <meta
    name="description"
    content="Pune to Ashtavinayak Cab by Citysky Cabs for comfortable Ganpati darshan. Book a private car rental for Ashtavinayak Yatra from Pune with Innova Crysta and Ertiga options."
  />

  <meta
    name="keywords"
    content="Pune to Ashtavinayak Cab, Ashtavinayak darshan cab Pune, Car rental for Ashtavinayak from Pune, Cost of Ashtavinayak yatra tour by car from Pune, Pune to Ashtavinayak, Pune to Ashtavinayak cab booking, Pune Ashtavinayak cab service, Ashtavinayak cab from Pune, Ashtavinayak taxi from Pune, Pune to Ashtavinayak car rental, Ashtavinayak Darshan from Pune, Ashtavinayak tour from Pune by car, Ashtavinayak Yatra from Pune, Ashtavinayak tour package from Pune, Pune to Ashtavinayak tour package, Ashtavinayak Darshan car rental Pune, Ashtavinayak Darshan taxi Pune, Ashtavinayak 8 Ganpati tour from Pune, 8 Ashtavinayak Darshan cab Pune, Pune Ashtavinayak round trip cab, Pune Ashtavinayak private cab, Pune Ashtavinayak Innova Crysta cab, Pune Ashtavinayak Ertiga cab, Innova Crysta for Ashtavinayak Darshan, Ertiga for Ashtavinayak Darshan, Ashtavinayak family tour cab Pune, Ashtavinayak temple tour by car Pune, Ashtavinayak pilgrimage cab Pune, Pune Ashtavinayak AC cab, Ashtavinayak outstation cab Pune, Ashtavinayak cab fare from Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakcabb;